import pageElementWithTransition from './src/utils/wrapPageElement'

export const wrapPageElement = pageElementWithTransition
